export const routes = {
  home: "/",
  joinWaitList: "/join-waitlist",
  joinWaitListThanks: "/join-waitlist-thanks",
};
